import {
  SCTopBarContainer,
  SCTopBarLabel,
  SCTopBarLabelWrapper,
} from 'components/AugmentedReality/Structure/TopBar/styled'

interface TopBarProps {
  label: string;
}
const TopBar = ({ label }: TopBarProps) => {
  return (
    <SCTopBarContainer>
      <SCTopBarLabelWrapper>
        <SCTopBarLabel>{label}</SCTopBarLabel>
      </SCTopBarLabelWrapper>
    </SCTopBarContainer>
  )
}

export default TopBar